import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import BackButton from '../../components/common/BackButton';

const InsuranceManagement = () => {
  const { t } = useTranslation();
  const [insurances, setInsurances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    name: ''
  });

  useEffect(() => {
    fetchInsurances();

  }, []);

  const fetchInsurances = async () => {
    try {
      const response = await axios.get('https://hasanhaji.com/api/insurance');
      setInsurances(response.data);
      setLoading(false);
    } catch (err) {
      setError(t('admin.errorLoadingInsurance'));
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageUpload = async (e) => {
    e.preventDefault();

    const fileInput = document.getElementById('insuranceImage');
    const file = fileInput.files[0];

    if (!file) {
      setError(t('admin.selectInsuranceImage'));
      return;
    }

    const formDataToSend = new FormData();
    if (formData.name) {
      formDataToSend.append('name', formData.name);
    }
    formDataToSend.append('image', file);

    setUploading(true);
    setError('');

    try {
      const response = await axios.post('https://hasanhaji.com/api/insurance', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setInsurances([response.data, ...insurances]);
      setFormData({ name: '' });
      fileInput.value = '';
      setUploading(false);




      const modalElement = document.getElementById('addInsuranceModal');
      const modalBackdrop = document.querySelector('.modal-backdrop');
      if (modalElement) {
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        modalElement.setAttribute('aria-hidden', 'true');
        modalElement.removeAttribute('aria-modal');
        modalElement.removeAttribute('role');
      }
      if (modalBackdrop) {
        modalBackdrop.remove();
      }
      document.body.classList.remove('modal-open');
      document.body.style = '';

    } catch (err) {
      setError(t('admin.errorUploadingInsurance'));
      setUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(t('admin.confirmDeleteInsurance'))) {
      return;
    }

    try {
      await axios.delete(`https://hasanhaji.com/api/insurance/${id}`);
      setInsurances(insurances.filter(insurance => insurance.id !== id));
    } catch (err) {
      setError(t('admin.errorDeletingInsurance'));
    }
  };

  return (
    <div className="container py-5">
      <div className="d-flex align-items-center mb-4">
        <BackButton to="/admin" />

        <h2>{t('admin.manageInsuranceTitle')}</h2>
        <button
          className="btn btn-primary ms-auto"
          data-bs-toggle="modal"
          data-bs-target="#addInsuranceModal"
        >
          <i className="fas fa-plus me-2"></i>
          {t('admin.addInsuranceBtn')}
        </button>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          {insurances.map((insurance) => (
            <div className="col-md-6 col-lg-4 mb-4" key={insurance.id}>
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-3">
                    <img
                      src={insurance.imageUrl}
                      alt={insurance.name}
                      className="img-fluid"
                      style={{
                        maxHeight: '150px',
                        objectFit: 'contain',
                        padding: '10px',
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                  {insurance.name && <h5 className="card-title mt-3">{insurance.name}</h5>}
                  <div className="text-muted small mb-3">
                    {new Date(insurance.createdAt).toLocaleDateString('ar-BH')}
                  </div>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(insurance.id)}
                  >
                    <i className="fas fa-trash me-1"></i>
                    {t('admin.deleteInsurance')}
                  </button>
                </div>
              </div>
            </div>
          ))}

          {insurances.length === 0 && (
            <div className="col-12 text-center py-5">
              <i className="fas fa-shield-alt fa-3x text-muted mb-3"></i>
              <h5 className="text-muted">{t('admin.noInsuranceFound')}</h5>
              <p className="text-muted">{t('admin.startAddingInsurance')}</p>
            </div>
          )}
        </div>
      )}

      { }
      <div className="modal fade" id="addInsuranceModal" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t('admin.addInsuranceModalTitle')}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <form onSubmit={handleImageUpload}>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="insuranceName" className="form-label">{t('admin.insuranceName')}</label>
                  <input
                    type="text"
                    className="form-control"
                    id="insuranceName"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder={t('admin.insuranceNamePlaceholder')}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="insuranceImage" className="form-label">{t('admin.insuranceImage')}</label>
                  <input
                    type="file"
                    className="form-control"
                    id="insuranceImage"
                    accept="image/*"
                    required
                  />
                  <div className="form-text">
                    {t('admin.insuranceImageHelp')}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  {t('admin.cancel')}
                </button>
                <button type="submit" className="btn btn-primary" disabled={uploading}>
                  {uploading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      {t('admin.uploadingInsurance')}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-upload me-2"></i>
                      {t('admin.addInsuranceSubmit')}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsuranceManagement;
